import { NO_FILTERS } from "../lib/NO_FILTERS";
import { useMatchHistory } from "./useMatchHistory";

// Последние матчи игрока без фильтров — первая страница истории (20 матчей), новые сверху.
// Тот же запрос, что у списка матчей без фильтров: сводка, последний разбор и список
// читают один кэш.
export const useMatches = () => {
  const { query, isWaitingForHistory } = useMatchHistory(NO_FILTERS);
  return { query, items: query.data?.pages[0]?.items ?? [], isWaitingForHistory };
};
